import { useEffect, useState } from "react";
import { Sparkles, X, ArrowRight } from "lucide-react";

const KEY = "announce_carloforte_v1";
const BAR_HEIGHT = 40; // px

function setBarHeight(px) {
  document.documentElement.style.setProperty("--announce-h", `${px}px`);
}

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        setVisible(true);
        setBarHeight(BAR_HEIGHT);
      } else {
        setBarHeight(0);
      }
    } catch {
      setVisible(true);
      setBarHeight(BAR_HEIGHT);
    }
    return () => setBarHeight(0);
  }, []);

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      localStorage.setItem(KEY, "1");
    } catch {}
    setBarHeight(0);
    setVisible(false);
  };

  const scrollToStudi = (e) => {
    e.preventDefault();
    const el = document.getElementById("dove-ricevo");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  if (!visible) return null;

  return (
    <a
      href="#dove-ricevo"
      onClick={scrollToStudi}
      data-testid="announcement-bar"
      className="fixed top-0 left-0 right-0 z-[60] block bg-[#0B4A5A] text-white overflow-hidden group"
      style={{
        height: `${BAR_HEIGHT}px`,
        backgroundImage:
          "linear-gradient(90deg, rgba(198,168,107,0.14) 0%, rgba(11,74,90,0) 40%, rgba(11,74,90,0) 60%, rgba(198,168,107,0.14) 100%)",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-full flex items-center justify-center gap-3 text-[12px] md:text-[13px] relative">
        <Sparkles
          size={14}
          className="text-[#C6A86B] flex-shrink-0 hidden sm:block"
          strokeWidth={1.8}
        />
        <p className="text-center leading-tight">
          <span className="text-[#C6A86B] font-medium tracking-[0.12em] uppercase text-[10px] md:text-[11px]">
            Novità
          </span>
          <span className="mx-2 text-white/40">·</span>
          <span className="text-white/90">
            Nuovo studio a <strong className="text-white">Carloforte</strong>{" "}
            dal <strong className="text-white">7 novembre 2026</strong>
          </span>
          <span className="hidden md:inline text-white/40 mx-2">·</span>
          <span className="hidden md:inline text-[#C6A86B] font-medium">
            Prenotazioni già aperte
          </span>
          <ArrowRight
            size={13}
            strokeWidth={2}
            className="inline-block ml-2 -mt-0.5 transition-transform group-hover:translate-x-1"
          />
        </p>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Chiudi annuncio"
          data-testid="announcement-close"
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition p-1"
        >
          <X size={14} strokeWidth={2} />
        </button>
      </div>
    </a>
  );
}
